import BaseModel from "./BaseModel"

export default class SipModel extends BaseModel {
    get schema() {
        return {
            // author: null,
            taskUsers: [],
            status: 10,
            // //новая
            // const STATUS_NEW = 10;
            // //В работе
            // const STATUS_IN_WORK = 20;
            // //завершена
            // const STATUS_COMPLETE = 30;
            // //отменена
            // const STATUS_CANCEL = 40;

            type: 10,
            // //Общая
            // const TYPE_DEFAULT = 10;
            // //перезвонить
            // const TYPE_CALL = 20;
            date_created: "",
            date_start: "", // new Date().toISOString().substr(0, 10),
            date_end: "", // new Date().toISOString().substr(0, 10),
            date_completed: "",
            event_created: [],
            event_created_author: [],
            description: "",
            tender_id: null,
            package_id: null,
            name: "",
            // backgroundColor: { hex: "aaaaaa" }
        }
    }

    prepareCreate() {
        this.baseClear()

        return this
    }

    prepareUpdate() {
        this.baseClear()

        return this
    }
}
